import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { createHttpPortalApi } from "./api/httpPortalApi";
import { createHttpAuthApi } from "./auth/httpAuthApi";
import "@bigbear/brand/tokens.css";
import "./styles.css";

/**
 * Built once, at module scope, and not per render.
 *
 * `useOverview`'s effect is keyed on the api object, so a factory called inline
 * in JSX would hand it a new identity every render and refetch the dashboard
 * forever.
 */
const portalApi = createHttpPortalApi();
const authApi = createHttpAuthApi();

const container = document.getElementById("root");
if (!container) {
  throw new Error("index.html is missing its #root element");
}

createRoot(container).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* Both talk to the deployed worker. The synthetic overview has not gone
          away — it moved to `/demo`, which anyone can browse without an
          account (see `App.tsx`). */}
      <App api={portalApi} authApi={authApi} />
    </BrowserRouter>
  </React.StrictMode>,
);
